<template>
  <div>
    <h1>Stock Availability</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :date_filter="false"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Stock By Location & Stats Start -->
    <stock-by-location
      :filterUrl="filterUrl"
    ></stock-by-location>
    <!-- Stock By Location & Stats End-->

    <!-- Stock Availability By Category And Segment Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Stock Availability By Category And Segment</h5>
      <stock-availability-by-category-and-segment
        :filterUrl="filterUrl"
        @getSegment="setSubSeriesTypeFilter"
      ></stock-availability-by-category-and-segment>
    </div>
    <!-- Stock Availability By Category And Segment End -->

    <!-- Stock Availability By Sub Series And Type Start -->
    <div class="innerBox mt-5" v-if="shown.subSeriesType">
      <h5 class="mb-2">Stock Availability By Sub-Series And Type</h5>
      <stock-availability-by-sub-series-and-type
        :filterUrl="subSeriesTypeFilterUrl"
        @getCodeMarket="setCodeMarketFilter"
      ></stock-availability-by-sub-series-and-type>
    </div>
    <!-- Stock Availability By Sub Series And Type End -->

    <!-- Stock Availability By Code Market Start -->
    <div class="innerBox mt-5" v-if="shown.codeMarket">
      <h5 class="mb-2">Stock Availability By Code (Market Name)</h5>
      <stock-availability-by-code-market
        :filterUrl="codeMarketFilterUrl"
      ></stock-availability-by-code-market>
    </div>
    <!-- Stock Availability By Code Market End -->
  </div>
</template>

<script>
  import qs from 'qs'

  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import stockByLocation from './children/stockByLocation'
  import stockAvailabilityByCategoryAndSegment from './children/stockAvailabilityByCategoryAndSegment'
  import stockAvailabilityBySubSeriesAndType from './children/stockAvailabilityBySubSeriesAndType'
  import stockAvailabilityByCodeMarket from './children/stockAvailabilityByCodeMarket'

  export default {
    data () {
      return {
        filterUrl : '',
        subSeriesTypeFilterUrl : '',
        codeMarketFilterUrl : '',
        
        shown : {
          subSeriesType : false,
          codeMarket : false,
        },

        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      stockByLocation,
      stockAvailabilityByCategoryAndSegment,
      stockAvailabilityBySubSeriesAndType,
      stockAvailabilityByCodeMarket,
    },
    mounted () {
      this.fetchFilter++;
    },
    watch : {
      'filterUrl' : function(){
        this.subSeriesTypeFilterUrl = this.filterUrl;

        this.shown.subSeriesType = false;
        this.shown.codeMarket = false;
      }
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      },
      setSubSeriesTypeFilter(value){
        //load and create chart first (no data yet)
        this.shown.subSeriesType = true;

        var finalFilterUrl = this.filterUrl
        if(this.filterUrl.includes('segment')){
          let obj = qs.parse(this.filterUrl)
          obj['segment'] = `${obj['segment']},${value}`

          finalFilterUrl = qs.stringify(obj)
          finalFilterUrl = finalFilterUrl.replace(/%2C/g, ',')
        } else {
          finalFilterUrl = `${this.filterUrl}&segment=${value}`
        }
        setTimeout(()=>{
          this.subSeriesTypeFilterUrl = finalFilterUrl
          window.scrollTo(0, document.body.scrollHeight);
        }, 200)
      },
      setCodeMarketFilter(value){
        //load and create chart first (no data yet)
        this.shown.codeMarket = true;

        var finalFilterUrl = this.subSeriesTypeFilterUrl
        if(this.filterUrl.includes('type')){
          let obj = qs.parse(this.subSeriesTypeFilterUrl)
          obj['type'] = `${obj['type']},${value}`

          finalFilterUrl = qs.stringify(obj)
          finalFilterUrl = finalFilterUrl.replace(/%2C/g, ',')
        } else {
          finalFilterUrl = `${this.subSeriesTypeFilterUrl}&type=${value}`
        }
        setTimeout(()=>{
          this.codeMarketFilterUrl = finalFilterUrl
          window.scrollTo(0, document.body.scrollHeight);
        }, 200)
      }
    }
  }
</script>

<style scoped>
  
</style>